import {
  packNumbersForAPI,
  unpackNumbersForUI,
} from '@/sections/insights/queryBuilder/entities/common/multiValueHelpers';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

/**
 * Reusable field definition for Port number
 * Uses integer input with validation for standard TCP/UDP port range (1-65535)
 * Supports numeric comparison and set operators
 */
export const PortNumber: SimpleFilterDefinition = {
  apiField: 'port',
  uiField: 'Port Number',
  inputType: 'number',
  getAvailableValues: () => Promise.resolve([]), // No predefined values
  operators: ['is', 'is not', 'is any of', 'is none of'],

  validation: {
    min: 1,
    max: 65535,
    required: true,
  },

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    const operator = getOperatorFromQueryFilter(queryFilter);
    const uiValue = unpackNumbersForUI(queryFilter.value, operator);

    return {
      field: 'Port Number',
      operator,
      value: uiValue,
    };
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    const operator = getOperatorFromSimpleFilter(simpleFilter);
    const apiValue = packNumbersForAPI(
      simpleFilter.value,
      simpleFilter.operator
    );

    return {
      field: 'port',
      operator,
      value: apiValue,
      not: getNotFromSimpleFilter(simpleFilter),
    };
  },
};
